import { render, staticRenderFns } from "./ElementsStructure.vue?vue&type=template&id=2f81f66d&"
import script from "./ElementsStructure.vue?vue&type=script&lang=js&"
export * from "./ElementsStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports